import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Plateform = () => {
  return (
    <>
    <Navbar />

      <div style={{ background: "#f8f9fa", paddingTop: "98px", paddingBottom: "50px" }}>
        <Container>

          {/* HERO SECTION */}
          <Row className="text-center mb-5">
            <Col>
              <h1 className="fw-bold mb-3" style={{ color: "#1155cc" }}>
                DiscloseAI
              </h1>
              <p className="lead text-muted">
                Move from static documents to interactive Sustainability Disclosure Agents.
              </p>
            </Col>
          </Row>

          {/* OVERVIEW */}
          <Row className="mb-5">
            <Col lg={10} className="mx-auto text-center">
              <p className="fs-5 text-muted">
                DiscloseAI is more than a chatbot — it is a specialized AI assistant Sustainability Disclosure Agent
                designed to bridge the transparency gap. It sits as an intelligent layer on your website,
                allowing stakeholders to chat with your project or corporate disclosures in real-time.
              </p>
            </Col>
          </Row>

          {/* DEPLOYMENT OPTIONS */}
          <Row className="mb-5">
            <Col>
              <h2 className="fw-bold mb-4 text-center">Versatile Deployment</h2>
            </Col>
          </Row>

          <Row className="g-4 mb-5">
            <Col md={4}>
              <Card className="shadow-sm h-100 border-0">
                <Card.Body>
                  <Card.Title>Single Project Focus</Card.Title>
                  <Card.Text>
                    Ideal for local ESIAs, community engagement, and specific project disclosures.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="shadow-sm h-100 border-0">
                <Card.Body>
                  <Card.Title>Corporate Portfolio</Card.Title>
                  <Card.Text>
                    Scale the Agent to manage your annual sustainability reporting and global disclosures.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="shadow-sm h-100 border-0">
                <Card.Body>
                  <Card.Title>Fully Customizable</Card.Title>
                  <Card.Text>
                    Match the Agent’s interface to your brand with custom colors, logos, and fonts.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* KEY CAPABILITIES */}
          <Row className="mb-4">
            <Col>
              <h2 className="fw-bold text-center">Key Capabilities</h2>
            </Col>
          </Row>

          <Row className="g-4 mb-5">
            <Col md={6}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Title>Verified ESG Intelligence</Card.Title>
                  <ul>
                    <li>Answers only from your uploaded documents</li>
                    <li>No speculation or hallucinations</li>
                    <li>Direct citations with page & paragraph references</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Title>Custom Stakeholder Feedback Loop</Card.Title>
                  <ul>
                    <li>Secure grievance management</li>
                    <li>Feedback collaboration mode</li>
                    <li>Full module control & flexibility</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Title>Inclusive & Global Engagement</Card.Title>
                  <ul>
                    <li>Multilingual queries</li>
                    <li>Voice & text input support</li>
                    <li>Accessible to all stakeholders</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Title>Defend Against Greenwashing</Card.Title>
                  <ul>
                    <li>All claims linked to factual sources</li>
                    <li>Audit-ready interaction logs</li>
                    <li>Instant access to key ESG metrics</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* STAR PLATFORM SECTION */}
          <Row className="text-center mb-4">
            <Col>
              <h2 className="fw-bold" style={{ color: "#1155cc" }}>
                The STAR Platform
              </h2>
              <p className="text-muted">
                Sustainability ESG Reporting Analysis Tracking and Reporting
              </p>
              <p className="fst-italic">
                Built around AI, not the other way around.
              </p>
            </Col>
          </Row>

          <Row className="g-4 mb-5">
            <Col md={4}>
              <Card className="shadow-sm h-100 border-0">
                <Card.Body>
                  <Card.Title>Proprietary Meta-Tagging</Card.Title>
                  <Card.Text>
                    Dynamically map your data across IFRS, SASB, GRI, and CSRD standards.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="shadow-sm h-100 border-0">
                <Card.Body>
                  <Card.Title>AI-First Architecture</Card.Title>
                  <Card.Text>
                    Automated drafting, anomaly detection, and reporting synthesis.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="shadow-sm h-100 border-0">
                <Card.Body>
                  <Card.Title>Enterprise & SME Scalable</Card.Title>
                  <Card.Text>
                    Enterprise-grade for global portfolios. SME version for best-practice reporting.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Col md={12}>
              <Card className="h-100 shadow-sm border-0 text-center">
                <Card.Body>
                  <Card.Title>The Value Proposition</Card.Title>
                  <ul>
                    <li style={{justifyContent: 'center', display: 'flex'}}>Dynamic Reporting: Stop treating your sustainability report as a static, annual event. STAR allows for continuous tracking and real-time analysis.</li>
                    <li style={{justifyContent: 'center', display: 'flex'}}>Audit-Ready Data: Every data point is traceable, ensuring that when it’s time for assurance, your "Audit Trail" is robust and transparent.</li>
                    <li style={{justifyContent: 'center', display: 'flex'}}>A Modernized Dialogue: Integrated seamlessly with DiscloseAI, the STAR platform ensures that once your data is tracked, it is immediately ready for stakeholder engagement.</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12}>
              <Card className="h-100 shadow-sm border-0 text-center">
                <Card.Body>
                  <Card.Title>Development Status: 2026 Launch</Card.Title>
                  <ul>
                    <li style={{justifyContent: 'center', display: 'flex'}}>The STAR Platform is currently in its final stages of development. We are partnering with select Enterprise and SME clients for early-access testing.</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

          {/* CTA */}
          <Row className="text-center mt-5">
  <Col>
    <Button
      as="a"
      href="mailto:info@essolutions.ai?subject=STAR%20Platform%20Early%20Access%20Inquiry"
      size="lg"
      style={{
        backgroundColor: "#1155cc",
        border: "none",
        padding: "12px 40px",
        borderRadius: "30px",
      }}
    >
      Request a Demo
    </Button>
  </Col>
</Row>

        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Plateform;